import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { IssueLink } from 'types';

type CreateIssueLinkData = {
  sourceIssue: string;
  targetIssue: string;
  linkType: IssueLink['linkType'];
};

const createIssueLink = async (linkData: CreateIssueLinkData): Promise<IssueLink> => {
  const { data } = await customAxios.post<IssueLink>('/issue-links', linkData);
  return data;
};

export const useCreateIssueLink = (issueId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createIssueLink,
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['issue-links', issueId] }).catch(() => undefined);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['issues', issueId] }).catch(() => undefined);
    },
  });
};
